import { Component, EventEmitter, OnInit, Input, Output, Inject } from '@angular/core';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-confirm-email-modal',
  templateUrl: './confirm-email-modal.component.html',
  styleUrls: ['./confirm-email-modal.component.scss'],
  providers: [ApiService, GlobalConstants]
})
export class ConfirmEmaiModalComponent implements OnInit {
  isLoading = false;
  @Input() existingEmail: string;
  // @Input() existingEmail: string;
  @Output() hideEvent: EventEmitter<boolean> = new EventEmitter();

  formSubmited = false;
  emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  createWithUserForm: any = this.fb.group({
    email: ['', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]]
  });
  get f() { return this.createWithUserForm.controls; }

  constructor(
    public GlobalConstants: GlobalConstants,
    private _apiService: ApiService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    @Inject(DOCUMENT) private document: any,
  ) { }

  ngOnInit(): void {
    this.createWithUserForm.patchValue({ email: this.existingEmail });
  }
  submitEmailChange(){
    if(!this.isLoading){
      this.formSubmited = true;
      if (this.createWithUserForm.valid) {
        this.isLoading = true;
        if(this.f.email.value === this.existingEmail){
          this.resendEmail();
        }
        else{
          this.updateEmail()
        }
      } else {
        this.isLoading = false;
        return false;
      }
    }
  }
  resendEmail(){
    // let param = {
    //   verification_source_page: this.document.location.pathname
    // }
    const formData: FormData = new FormData();
    formData.append("verification_source_page", this.document.location.pathname);
    this._apiService.resendEmail(formData).subscribe((res: any) => {
      if(res){
        if(res.resp == true){
          this.toastr.success('Email sent. Please click on the verification link sent to your email!','', {
            timeOut: 6000,
          });
        }
        else if(res.resp == 'too_many'){
          this.toastr.warning('Limit exceeded. Please try after sometime!','', {
            timeOut: 6000,
          });
        }
        this.hideModal();
      }
      else{
        this.showToast('Something went wrong!',3000)
      }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.showToast('Something went wrong!',3000)
      }
    );
  }
  updateEmail(){
    const formData: FormData = new FormData();
    formData.append("email", this.f.email.value);
    formData.append("verification_source_page", this.document.location.pathname);
    this._apiService.updateUserCreds(formData).subscribe((res: any) => {
      this.toastr.success('Email updated. Please click on the verification link sent to your email!','', {
        timeOut: 6000,
      });
      this.isLoading = false;
      setTimeout(()=>{
        this.hideModal();
      }, 500)

    },
    (err) => {
      this.showToast('Something went wrong!',3000)
      }
    );
  }
  showToast(msg,secs){
    this.toastr.error(msg,'', {
      timeOut: secs,
    });
  }
  hideModal() {
    localStorage.setItem('emailVerified','skipped');
    if (window.innerWidth < 768) {
      this.hideEvent.emit(true);
    }
    else{
      this.hideEvent.emit(true);
    }

  }
}
